import { combineReducers } from 'redux';
import list from './jerseys/list';
import collections from './jerseys/collections';

export default combineReducers({
    list,
    collections,
});



// WEBPACK FOOTER //
// ./src/reducers/app/jerseys.js